export const itDict = {
  'Account recovery requires verified contact information':
    'Ripristino del conto richiede un account verificati',
  'An account with the given email already exists.':
    'Un account con questa email esiste già.',
  'Back to Sign In': 'Torna alla Accesso',
  'Change Password': 'Cambia la password',
  Code: 'Codice',
  Confirm: 'Conferma',
  'Confirm a Code': 'Codice Conferma',
  'Confirm Password': 'Conferma la password',
  'Confirm Sign In': 'Conferma di applicazione',
  'Confirm Sign Up': 'Registrazione Conferma',
  'Confirmation Code': 'Codice di verifica',
  'Create a new account': 'Creare un nuovo account',
  'Create account': 'Registrati',
  'Create Account': 'Crea account',
  Email: 'E-mail',
  'Enter your password': 'Inserire la password',
  'Enter your username': 'Inserisci il tuo nome utente',
  'Forgot Password': 'Password dimenticata',
  'Forgot your password? ': 'Password dimenticata?',
  'Have an account? ': 'Già registrato?',
  'Incorrect username or password': 'Nome utente o password errati',
  'Invalid password format': 'Formato della password non valido',
  'Invalid phone number format':
    'Utilizzo non valido Telefonummern formattare un numero nel formato :. 12.345.678,9 mille',
  'Lost your code?': 'Perso codice?',
  'New Password': 'Nuova password',
  or: 'o',
  'No account? ': 'Nessun account?',
  Password: 'Password',
  'Password attempts exceeded':
    'Il numero massimo di tentativi di accesso falliti è stato raggiunto',
  'Phone Number': 'Numero di telefono',
  'Resend Code': 'Codice Rispedisci',
  'Reset password': 'Ripristina password',
  'Reset your password': 'Resetta password',
  'Send Code': 'Invia codice',
  'Sign in': 'Accesso',
  'Sign In': 'Accesso',
  'Sign in to your account': 'Accedi con il tuo account a',
  'Sign Out': 'Esci',
  'Sign Up': 'Iscriviti',
  Skip: 'Salta',
  Submit: 'Sottoscrivi',
  'User already exists': 'Questo utente esiste già',
  'User does not exist': 'Questo utente non esiste',
  Username: 'Nome utente',
  'Username cannot be empty': 'Nome utente non può essere vuoto',
  Verify: 'Verifica',
  'Verify Contact': 'Contatto verifica',
};
